// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonSwitch_container__2VoF3","basicButton":"ButtonSwitch_basicButton__2V3Az","selected":"ButtonSwitch_selected__2pfT1","unSelected":"ButtonSwitch_unSelected__1J2d8"};